import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import Flex from '../Flex';

import type { ContentRowProps } from './ContentRow.types';
import { useAppLayoutGutterSize, useContentRowPadding } from './hooks';

const ContentRow: FC<PropsWithChildren<ContentRowProps>> = ({ children, role, grow }) => {
  const gutterSize = useAppLayoutGutterSize();
  const { horizontalPadding, paddingLeft } = useContentRowPadding();

  return (
    <Flex
      horizontalPadding={horizontalPadding}
      paddingLeft={paddingLeft}
      columnGap={gutterSize}
      grow={grow}
      role={role}
      className="qaContentRow"
    >
      {children}
    </Flex>
  );
};

export default ContentRow;
